export function extractHostname(
  urlString: string | undefined | null
): string | null {
  if (!urlString) {
    return null;
  }

  try {
    return new URL(urlString).hostname;
  } catch {
    const parts = urlString.split('/');
    const hostPart = parts[0];
    return hostPart?.split(':')[0] || null;
  }
}

export function normalizeHostname(
  hostname: string | undefined | null
): string | null {
  if (!hostname) {
    return null;
  }

  return hostname.trim().toLowerCase().replace(/\.$/, '');
}

export function hasDifferentInstanceHostname(
  currentInstanceUrl: string | undefined | null,
  nextInstanceUrl: string | undefined | null
): boolean {
  const currentHostname = normalizeHostname(
    extractHostname(currentInstanceUrl)
  );
  const nextHostname = normalizeHostname(extractHostname(nextInstanceUrl));

  return Boolean(
    currentHostname && nextHostname && currentHostname !== nextHostname
  );
}
